import React, { useEffect, useState, useRef } from 'react';
import baseURL from '../url';
import './Products.css';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay } from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDoubleRight, faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ProductosLoading from '../ProductosLoading/ProductosLoading';
import { Link as Anchor } from "react-router-dom";
import moneda from '../moneda';
import VenderAuto from '../VenderAuto/VenderAuto';
import BuscarCeroKm from '../BuscarCeroKm/BuscarCeroKm';
import PorQueElegirnos from '../PorQueElegirnos/PorQueElegirnos';
import Financiacion from '../Financiacion/Financiacion';
import Ubicacion from '../Ubicacion/Ubicacion';
import ComprarMoto from '../ComprarMoto/ComprarMoto';
import LazyImage from '../LazyImage';

export default function Products() {
    const [categorias, setCategorias] = useState([]);
    const [loading, setLoading] = useState(true);
    const [fixedCategories, setFixedCategories] = useState(false);
    const categoriasRefs = useRef([]);
    const categoriasInputRef = useRef(null);
    const [productos, setProductos] = useState([]);
    const [categoriaSeleccionada, setCategoriaSeleccionada] = useState('Destacados');

    const handleClickCategoria = (categoria) => {
        setCategoriaSeleccionada(categoria);
    };

    useEffect(() => {
        cargarProductos();
        cargarCategorias();

        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    const handleScroll = () => {
        if (categoriasInputRef.current) {
            if (window.scrollY > categoriasInputRef.current.offsetTop) {
                setFixedCategories(true);
            } else {
                setFixedCategories(false);
            }
        }
    };

    const cargarProductos = () => {
        fetch(`${baseURL}/productosGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setProductos(data.productos);
                setLoading(false);
            })
            .catch(error => console.error('Error al cargar productos:', error));
    };

    const cargarCategorias = () => {
        fetch(`${baseURL}/categoriasGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setCategorias(data.categorias || []);
            })
            .catch(error => console.error('Error al cargar categorías:', error));
    };

    const obtenerImagen = (item) => {
        if (item.imagen1) {
            return item.imagen1;
        } else if (item.imagen2) {
            return item.imagen2;
        } else if (item.imagen3) {
            return item.imagen3;
        } else if (item.imagen4) {
            return item.imagen4;
        }
        return null;
    };

    const categoriasConProductos = categorias.filter(categoria =>
        productos?.some(producto => producto?.idCategoria === categoria?.idCategoria)
    );

    const allCategorias = categorias;

    return (
        <>
            {/* Sección de título destacados */}
            <div className='vehiculos-destacados-section speed'>
                <h1 className='vehiculos-destacados-title'>VEHiCULOS DESTACADOS</h1>
                <p className='vehiculos-destacados-subtitle'>Aprovechá estas oportunidades únicas, <br />no aparecen todos los días.</p>
            </div>

            <div className='ProductsContain'>
                <ToastContainer />
                {productos?.length > 0 && (
                    <div className={`categoriasInputs ${fixedCategories ? 'fixed' : ''}`} ref={categoriasInputRef}>
                        <input
                            type="button"
                            value="Destacados"
                            onClick={() => handleClickCategoria('Destacados')}
                            style={{
                                backgroundColor: categoriaSeleccionada === 'Destacados' ? '#00416A' : '',
                                color: categoriaSeleccionada === 'Destacados' ? '#fff' : '',
                                borderBottom: categoriaSeleccionada === 'Destacados' ? '2px solid #fbd4d2' : 'none'
                            }}
                        />
                        {categoriasConProductos.map(({ categoria, idCategoria }) => (
                            <input
                                key={idCategoria}
                                type="button"
                                value={categoria}
                                onClick={() => handleClickCategoria(idCategoria)}
                                style={{
                                    backgroundColor: categoriaSeleccionada === idCategoria ? '#00416A' : '',
                                    color: categoriaSeleccionada === idCategoria ? '#fff' : '',
                                    borderBottom: categoriaSeleccionada === idCategoria ? '2px solid #fbd4d2' : 'none'
                                }}
                            />
                        ))}
                    </div>
                )}

                {loading ? (
                    <ProductosLoading />
                ) : (
                    <div className='Products'>
                        {categoriaSeleccionada === 'Destacados' && (
                            <>
                                {productos?.some(item => item.masVendido === "si") && (
                                    <div className='categoriSection'>
                                        <div className='swiper-container-wrapper'>
                                            {/* Flecha izquierda para más vendidos */}
                                            <div className="swiper-button-prev-custom swiper-button-prev-masvendidos">
                                                <FontAwesomeIcon icon={faChevronLeft} />
                                            </div>

                                            <Swiper
                                                modules={[Navigation, Pagination, Autoplay]}
                                                effect={'coverflow'}
                                                grabCursor={true}
                                                slidesPerView={'auto'}
                                                id='swiper_container_products'
                                                navigation={{
                                                    nextEl: '.swiper-button-next-masvendidos',
                                                    prevEl: '.swiper-button-prev-masvendidos',
                                                }}
                                            >
                                                {productos?.filter(item => item.masVendido === "si").map(item => (
                                                    <SwiperSlide key={item.idProducto} id='SwiperSlide-scroll-products-masvendidos'>
                                                        <Anchor className='cardProdcutmasVendido' to={`/producto/${item.idProducto}/${item.titulo.replace(/\s+/g, '-')}`}>
                                                            <LazyImage src={obtenerImagen(item)} alt="imagen" useWebP={false} />
                                                            <h6 className='masVendido'>DESTACADOS</h6>
                                                            <div className='cardText'>
                                                                <h4>{item.titulo}</h4>
                                                                <span>{item.descripcion}</span>
                                                                <div className='deFLexPrice'>
                                                                    <h5> {moneda} {String(item?.precio)?.replace(/\B(?=(\d{3})+(?!\d))/g, ".")}</h5>
                                                                    {(item.precioAnterior >= 1 && item.precioAnterior !== undefined) && (
                                                                        <h5 className='precioTachado'>{moneda} {`${item?.precioAnterior}`.replace(/\B(?=(\d{3})+(?!\d))/g, ".")}</h5>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </Anchor>
                                                    </SwiperSlide>
                                                ))}
                                            </Swiper>

                                            {/* Flecha derecha para más vendidos */}
                                            <div className="swiper-button-next-custom swiper-button-next-masvendidos">
                                                <FontAwesomeIcon icon={faChevronRight} />
                                            </div>
                                        </div>
                                    </div>
                                )}


                            </>
                        )}

                        <div className='categoriSectionSelected'>
                            {productos
                                ?.filter(item => categoriaSeleccionada !== 'Destacados' && item.idCategoria === categoriaSeleccionada)
                                ?.map(item => (
                                    <Anchor key={item.idProducto} to={`/producto/${item.idProducto}/${item.titulo.replace(/\s+/g, '-')}`}>
                                        <div className='cardProdcutSelected'>
                                            <LazyImage src={obtenerImagen(item)} alt="imagen" useWebP={false} />
                                            <div className='cardTextSelected'>
                                                <h4>{item.titulo}</h4>
                                                <span>{item.descripcion}</span>
                                                <div className='deFLexPrice'>
                                                    <h5> {moneda} {String(item?.precio)?.replace(/\B(?=(\d{3})+(?!\d))/g, ".")}</h5>
                                                    {(item.precioAnterior >= 1 && item.precioAnterior !== undefined) && (
                                                        <h5 className='precioTachado'>{moneda} {`${item?.precioAnterior}`.replace(/\B(?=(\d{3})+(?!\d))/g, ".")}</h5>
                                                    )}
                                                </div>
                                                <FontAwesomeIcon icon={faAngleDoubleRight} className='iconCard' />
                                            </div>
                                        </div>
                                    </Anchor>
                                ))}
                        </div>
                    </div>
                )}
            </div>

            <VenderAuto />
            <BuscarCeroKm />
            <PorQueElegirnos />
            <ComprarMoto />
            <Financiacion />
            <Ubicacion />


        </>
    );
}